import React from 'react';
import {connect} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import CircularProgress from '@material-ui/core/CircularProgress';
import {Link} from 'react-router-dom';
import IntlMessages from 'util/IntlMessages';
import {
  hideMessage,
  showAuthLoader,
  userSignUp,
} from 'actions/Auth';
import InstitutionNativeSelect from '../app/routes/Institutions/InstitutionNativeSelect';
import SimpleSelect from '../app/routes/SimpleSelect/SimpleSelect';
import {config} from '../config';
import ReCAPTCHA from "react-google-recaptcha";
import { FormControl, FormLabel, MenuItem , Radio,FormControlLabel,RadioGroup, Checkbox, FormHelperText} from '@material-ui/core';
import KVKKDialog from '../app/routes/dialogs/KVKKDialog';
import { Alert } from '@material-ui/lab';


const isValidTCKimlikNo = (value) => {
  if (!value) {
    return false;
  }

  const normalized = `${value}`.trim();

  if (!/^[1-9][0-9]{10}$/.test(normalized)) {
    return false;
  }

  const digits = normalized.split('').map(Number);
  const oddSum = digits[0] + digits[2] + digits[4] + digits[6] + digits[8];
  const evenSum = digits[1] + digits[3] + digits[5] + digits[7];
  const checkDigit10 = ((oddSum * 7) - evenSum) % 10;
  const normalizedCheckDigit10 = (checkDigit10 + 10) % 10;

  if (normalizedCheckDigit10 !== digits[9]) {
    return false;
  }

  const total = digits.slice(0, 10).reduce((acc, digit) => acc + digit, 0);
  const checkDigit11 = total % 10;

  return checkDigit11 === digits[10];
};

class SignUp extends React.Component {
  constructor() {
    super();
    this.state = {
      name: '', 
      surname:'',
      email: '',
      password: '',
      passwordReply:'',
      inst : "" ,
      title : '',
      identityNo:'',
      gender:"",
      nationality:"T.C.",
      tel:"",
      nationalityErrorText:"",
      genderErrorText : "",
      identity_noErrorText : '',
      nameErrorText: '', 
      surnameErrorText:'',
      emailErrorText:'',
      passwordErrorText:'',
      passwordReplyErrorText:'',
      institutionsErrorText:<IntlMessages id="signin.institutionMessage"/> ,
      kvkk:false,
      showKVKKDialog:false,
      yoksisStatus:false,
      academicStatus:"Çalışıyor",
      recaptchaLoaded: false
    };

    this.recaptchaRef = React.createRef();
    this.onChangeInstitutions = this.onChangeInstitutions.bind(this);
  }

  onChangeInstitutions = (value)=>{

    this.setState({
      inst : value,
      institutionsErrorText:""
    });
  }
  onChangeTitle = (value)=>{

    this.setState({
      title :value==="Diğer" ? "" : value
    });
  }
  onChangeGender = (value)=>{

    this.setState({
      gender :value
    });
  }
  validate = ()=>{
    let isError = false;
    const errors = {};

 
    if(this.state.name.length < 1){
      isError = true;
      errors.nameErrorText =<IntlMessages id="signin.errormessage.name"/>
    }

    if(this.state.surname.length < 1){
      isError = true;
      errors.surnameErrorText =<IntlMessages id="signin.errormessage.surname"/>
    }
    if(this.state.identityNo.length < 1){
      isError = true;
      errors.identity_noErrorText = this.state.nationality=== "T.C." ? <IntlMessages id="signin.errormessage.idetityNo"/> : <IntlMessages id="signin.errormessage.passportNo"/>
    }
    if(this.state.nationality === "T.C." && this.state.identityNo.length > 0){
      const identityDigits = this.state.identityNo.replace(/[^0-9]/g, '');

      if (identityDigits.length !== 11 || !isValidTCKimlikNo(identityDigits)) {
        isError = true;
        errors.identity_noErrorText = "Geçersiz T.C. kimlik numarası";
      }
    }
    if(this.state.email.length < 1){
      isError = true;
      errors.emailErrorText =<IntlMessages id="signin.errormessage.email"/>
    }
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;


    if(!emailRegex.test(this.state.email)){
      isError = true;
      errors.emailErrorText ="Email adresi geçersiz"
    }



    // if(this.state.gender.length < 1){
    //   isError = true;
    //   errors.genderErrorText =<IntlMessages id="signin.errormessage.gender"/>
    // }
    if(this.state.password.length < 6){
      isError = true;
      errors.passwordErrorText = <IntlMessages id="signin.errormessage.password"/>
    }
    if(this.state.passwordReply.length < 6){
      isError = true;
      errors.passwordReplyErrorText = <IntlMessages id="signin.errormessage.password"/>
    }
    if(this.state.passwordReply !== this.state.password){
      isError = true;
      errors.passwordErrorText = <IntlMessages id="signin.errormessage.passwordReply"/>
      errors.passwordReplyErrorText = <IntlMessages id="signin.errormessage.passwordReply"/>
    }
    if(this.state.institutionId === 0){
      isError = true;
      errors.institutionsErrorText = <IntlMessages id="signin.errormessage.institution"/>
     
    }
    if(this.state.nationality === ""){
      isError = true;
      errors.nationalityErrorText = <IntlMessages id="signin.errormessage.nationality"/>
     
    }
    if(!this.state.kvkk ){
      isError = true;
     // errors.kvkk = "KVKK metnini, onaylamadan devam edemezsiniz."
      NotificationManager.error( <IntlMessages id="signin.errormessage.kvkk"/>)
    }

    if(isError){
      this.setState({
        ...this.state,
        ...errors
      })
    }

    return isError;
  }

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 3000);
    }
    if (this.props.authUser !== null) {
      this.props.history.push('/');
    }
  }
  signUpFunc = (recaptchaToken) => {
    const {
      name,
      surname,
      email,
      password,
      gender,
      passwordReply,
       inst,
       title,
      identityNo,
      nationality,
      tel,
      kvkk,
      yoksisStatus
    } = this.state;

    this.props.showAuthLoader();
    this.props.userSignUp({
      email,
      password,
      name,
      surname,
      inst,
      identityNo,
      passwordReply,
      title,
      gender,
      lang: this.props.locale.locale,
      nationality,
      tel,
      kvkk,
      yoksisStatus: yoksisStatus ? 1 : 0,
      recaptchaToken,
    });
  }

  executeRecaptcha = () => {
    if (!this.state.recaptchaLoaded || !this.recaptchaRef.current) {
      NotificationManager.error('Güvenlik doğrulaması henüz hazır değil. Lütfen bekleyin.');
      return;
    }
    this.recaptchaRef.current.execute();
  };

  onRecaptchaSuccess = (value) => {
    if (!value) {
      return;
    }
    this.signUpFunc(value);
    if (this.recaptchaRef.current) {
      this.recaptchaRef.current.reset();
    }
  }

  onRecaptchaErrored = () => {
    NotificationManager.error('Güvenlik doğrulaması yüklenemedi. Lütfen sayfayı yenileyin.');
    if (this.recaptchaRef.current) {
      this.recaptchaRef.current.reset();
    }
  };

  onRecaptchaExpired = () => {
    NotificationManager.warning('Güvenlik doğrulamasının süresi doldu. Lütfen tekrar deneyin.');
    if (this.recaptchaRef.current) {
      this.recaptchaRef.current.reset();
    }
  };

  asyncScriptOnLoad = () => {
    this.setState({ recaptchaLoaded: true });
  };

  render() {
    const {
      name,
      surname,
      email,
      password,
      gender,
      passwordReply,
       //inst,
       yoksisStatus,
      identityNo,
      tel,
      kvkk,
      showKVKKDialog

    } = this.state;
    const {showMessage, loader, alertMessage} = this.props;
    return (
      <div
        className="app-signup-container d-flex justify-content-center align-items-start animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content">
          <div className="app-logo-content-signup d-flex align-items-center justify-content-center">
            <Link className="logo-lg" to="/" title="BBS">
            {
                this.props.locale.locale ==="en" ? 
                <img src={require("assets/images/bbs_logo/logo_buyuk_beyaz_en.png")} width="100px" alt="IIS" title="IIS"/> 
                :
                <img src={require("assets/images/bbs_logo/logo_buyuk_beyaz.png").default} width="150px" alt="BBS" title="BBS"/>
            }
             
            </Link>
          </div>

          <div className="app-login-content-signup">
            <div className="app-login-header">
              <h1><IntlMessages id="appModule.createAccount"/></h1>
            </div>

            <div className="app-login-form">
              <form method="post" action="/">
                <div className="signup-recaptcha">
                  <ReCAPTCHA
                    ref={this.recaptchaRef}
                    size="invisible"
                    onChange={this.onRecaptchaSuccess}
                    onErrored={this.onRecaptchaErrored}
                    onExpired={this.onRecaptchaExpired}
                    sitekey={config.googleCaptchaSiteKey}
                    asyncScriptOnLoad={this.asyncScriptOnLoad}
                  />
                </div>

                <div className="signup-section">
                  <h3 className="signup-section-title">Kişisel Bilgiler</h3>
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <TextField
                        error={this.state.nameErrorText === "" ? false : true}
                        required
                        type="text"
                        label={<IntlMessages id="user.name"/>}
                        onChange={(event) => this.setState({
                          name: event.target.value,
                          nameErrorText: ""
                        })}
                        fullWidth
                        defaultValue={name}
                        margin="normal"
                        className="mt-0 mb-2"
                        helperText={this.state.nameErrorText}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <TextField
                        error={this.state.surnameErrorText === "" ? false : true}
                        required
                        type="text"
                        label={<IntlMessages id="user.surname"/>}
                        onChange={(event) => this.setState({
                          surname: event.target.value,
                          surnameErrorText: ""
                        })}
                        fullWidth
                        defaultValue={surname}
                        margin="normal"
                        className="mt-0 mb-2"
                        helperText={this.state.surnameErrorText}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <FormControl component="fieldset" fullWidth className="nationality-form-control">
                        <FormLabel component="legend"><IntlMessages id="user.nationality"/></FormLabel>
                        <RadioGroup
                          row
                          aria-label="nationality"
                          name="nationality"
                          value={this.state.nationality === "T.C." || this.state.nationality === "" ? this.state.nationality : ""}
                          onChange={(event) => this.setState({
                            nationality: event.target.value === "" ? "" : event.target.value,
                            nationalityErrorText: "",
                            identityNo: "",
                            identity_noErrorText: ""
                          })}
                          className="nationality-radio-group"
                        >
                          <FormControlLabel value="T.C." control={<Radio />} label="T.C." />
                          <FormControlLabel value="" control={<Radio />} label={<IntlMessages id="other"/>} />
                          <TextField
                            disabled={this.state.nationality === "T.C."}
                            className="nationality-text-field"
                            type="text"
                            label={<IntlMessages id="user.nationality"/>}
                            value={this.state.nationality === "T.C." ? "" : this.state.nationality}
                            onChange={(event) => this.setState({
                              nationality: event.target.value,
                              nationalityErrorText: ""
                            })}
                            error={this.state.nationalityErrorText === "" ? false : true}
                            helperText={this.state.nationalityErrorText}
                          />
                        </RadioGroup>
                      </FormControl>
                      {this.state.nationality !== "T.C." && (
                        <Alert severity="info" className="mb-2">
                          Burada pasaport numarası veya kendi ülkenize ait kimlik numaranızı girebilirsiniz. Burada önemli olan sizi diğer kişilerden ayırıcı bilgiye ihtiyaçtır.
                        </Alert>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-12">
                      <TextField
                        error={this.state.identity_noErrorText === "" ? false : true}
                        required
                        type="text"
                        label={this.state.nationality === "T.C." ? <IntlMessages id="user.identityNo"/> : <IntlMessages id="user.passportNo"/>}
                        onChange={(event) => {
                          const value = event.target.value;

                          if (this.state.nationality === "T.C.") {
                            const identityDigits = value.replace(/[^0-9]/g, '');
                            let errorText = "";

                            if (identityDigits.length === 11 && !isValidTCKimlikNo(identityDigits)) {
                              errorText = "Geçersiz T.C. kimlik numarası";
                            }

                            this.setState({
                              identityNo: identityDigits,
                              identity_noErrorText: errorText
                            });
                          } else {
                            this.setState({
                              identityNo: value,
                              identity_noErrorText: ""
                            });
                          }
                        }}
                        fullWidth
                        value={identityNo}
                        margin="normal"
                        className="mt-0 mb-2"
                        helperText={this.state.identity_noErrorText}
                        inputProps={this.state.nationality === "T.C." ? { maxLength: 11, inputMode: "numeric" } : undefined}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <TextField
                        id="gender"
                        select
                        label={<IntlMessages id="user.gender"/>}
                        value={gender}
                        margin="normal"
                        fullWidth
                        className="mt-0 mb-2"
                        onChange={(event) => this.setState({gender: event.target.value})}
                        required
                      >
                        <MenuItem key={1} value={"Erkek"}>
                          <IntlMessages id="user.gender.man"/>
                        </MenuItem>
                        <MenuItem key={2} value={"Kadın"}>
                          <IntlMessages id="user.gender.woman"/>
                        </MenuItem>
                      </TextField>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-12">
                      <SimpleSelect
                        value={this.state.title}
                        list={config.titleList}
                        onChange={this.onChangeTitle}
                        title={<IntlMessages id="user.title"/>}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <TextField
                        required
                        type="tel"
                        onChange={(event) => {
                          this.setState({tel: event.target.value});
                        }}
                        label={<IntlMessages id="contact.mobilePhone"/>}
                        fullWidth
                        defaultValue={tel}
                        margin="normal"
                        className="mt-0 mb-2"
                      />
                    </div>
                  </div>
                </div>

                <div className="signup-section">
                  <h3 className="signup-section-title">Hesap Bilgileri</h3>
                  <div className="row">
                    <div className="col-md-4 col-12">
                      <TextField
                        required
                        type="email"
                        error={this.state.emailErrorText === "" ? false : true}
                        onChange={(event) => {
                          const emailValue = event.target.value;
                          const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

                          if (emailValue === "") {
                            this.setState({
                              email: emailValue,
                              emailErrorText: "Email adresi boş bırakılamaz"
                            });
                          } else if (!emailRegex.test(emailValue)) {
                            this.setState({
                              email: emailValue,
                              emailErrorText: "Geçerli bir email adresi giriniz"
                            });
                          } else {
                            this.setState({
                              email: emailValue,
                              emailErrorText: ""
                            });
                          }
                        }}
                        label={<IntlMessages id="user.email"/>}
                        fullWidth
                        defaultValue={email}
                        margin="normal"
                        className="mt-0 mb-2"
                        helperText={this.state.emailErrorText}
                      />
                    </div>
                    <div className="col-md-4 col-12">
                      <TextField
                        required
                        error={this.state.passwordErrorText === "" ? false : true}
                        type="password"
                        onChange={(event) => {
                          this.setState({
                            password: event.target.value,
                            passwordErrorText: ""
                          });
                          if (this.state.passwordReply === event.target.value) {
                            this.setState({passwordReplyErrorText: ""});
                          }
                        }}
                        label={<IntlMessages id="user.password"/>}
                        fullWidth
                        defaultValue={password}
                        margin="normal"
                        className="mt-0 mb-2"
                        helperText={this.state.passwordErrorText}
                      />
                    </div>
                    <div className="col-md-4 col-12">
                      <TextField
                        required
                        error={this.state.passwordReplyErrorText === "" ? false : true}
                        type="password"
                        onChange={(event) => {
                          this.setState({
                            passwordReply: event.target.value,
                            passwordReplyErrorText: ""
                          });
                          if (this.state.password === event.target.value) {
                            this.setState({passwordErrorText: ""});
                          }
                        }}
                        label={<IntlMessages id="user.passwordReply"/>}
                        fullWidth
                        defaultValue={passwordReply}
                        margin="normal"
                        className="mt-0 mb-2"
                        helperText={this.state.passwordReplyErrorText}
                      />
                    </div>
                  </div>
                </div>

                <div className="signup-section">
                  <h3 className="signup-section-title">Kurum Bilgileri</h3>
                  <div className="row">
                    <div className="col-md-5 col-12">
                      <FormControl component="fieldset" fullWidth className="academic-status-form-control">
                        <FormLabel component="legend">Çalışma Durumu</FormLabel>
                        <RadioGroup
                          row
                          aria-label="academicStatus"
                          name="academicStatus"
                          value={this.state.academicStatus}
                          onChange={(event) => this.setState({
                            academicStatus: event.target.value,
                            inst: event.target.value === "Çalışıyor" ? "" : event.target.value,
                            institutionsErrorText: ""
                          })}
                          className="academic-status-radio-group"
                        >
                          <FormControlLabel value="Çalışıyor" control={<Radio />} label="Çalışıyor" />
                          <FormControlLabel value="Emekli" control={<Radio />} label="Emekli" />
                          <FormControlLabel value="Diğer" control={<Radio />} label="Diğer" />
                        </RadioGroup>
                      </FormControl>
                    </div>
                    <div className="col-md-7 col-12">
                      {this.state.nationality === "T.C." && this.state.academicStatus === "Çalışıyor" ? (
                        <InstitutionNativeSelect
                          onChange={this.onChangeInstitutions}
                          institutionsErrorText={this.state.institutionsErrorText}
                          defaultValue={this.state.inst}
                        />
                      ) : (
                        <TextField
                          required
                          type="text"
                          error={this.state.institutionsErrorText === "" ? false : true}
                          onChange={(event) => {
                            this.setState({inst: event.target.value, institutionsErrorText: ""});
                          }}
                          label={<IntlMessages id="user.institutions"/>}
                          fullWidth
                          defaultValue={this.state.inst}
                          margin="normal"
                          className="mt-0 mb-2"
                          helperText={<IntlMessages id="signin.institutionMessage2"/>}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="signup-section signup-section-consent">
                  <div className="row">
                    <div className="col-12">
                      <FormControlLabel
                        control={<Checkbox checked={kvkk} onChange={(e, checked) => this.setState({kvkk: checked})} />}
                        label={
                          <span>
                            <Link
                              component="button"
                              to="#"
                              variant="body2"
                              onClick={() => {
                                this.setState({showKVKKDialog: true});
                              }}
                            >
                              <IntlMessages id="signin.kvkk"/>
                            </Link>
                            {' '}
                            <IntlMessages id="signin.kvkk2"/>
                          </span>
                        }
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-12">
                      <FormControlLabel
                        control={<Checkbox checked={yoksisStatus} onChange={(e, checked) => this.setState({yoksisStatus: checked})} />}
                        label={<span><IntlMessages id="signin.yokData"/></span>}
                      />
                      <FormHelperText>
                        Böylece kurumlarımızda etkinlik, yayın, bildiri, kol ve komisyonlarda görev alabilir, inceleyici olarak atanabilirsiniz.
                      </FormHelperText>

                      <Alert severity="info" className="mt-2">
                         YÖK entegrasyonu için e-Devlet hesabınızla giriş yapılması gerekmektedir. Giriş yapmak için <Link to="/signin">giriş </Link> sayfasınadaki "E-Devlet ile Giriş Yap" tıklayınız. Yalnızca Türk Vatandaşları için geçerlidir.
                        
                         
                      </Alert>
                    </div>
                  </div>
                </div>

                <div className="mb-2 d-flex align-items-center justify-content-between signup-button-container">
                  <Button
                    variant="contained"
                    disabled={!this.state.recaptchaLoaded}
                    onClick={() => {
                      const err = this.validate();
                      if (!err) {
                        this.executeRecaptcha();
                      }
                    }}
                    color="primary"
                    className="signup-submit-button"
                  >
                    <IntlMessages id="appModule.regsiter"/>
                  </Button>
                  <Link to="/signin" className="signup-link">
                    <IntlMessages id="signUp.alreadyMember"/>
                  </Link>
                </div>
              </form>
            </div>
          </div>

        </div>
        {
          showKVKKDialog &&
          <KVKKDialog open={showKVKKDialog} onClose={()=>this.setState({showKVKKDialog:false})} />
        }

        {
          loader &&
          <div className="loader-view">
            <CircularProgress/>
          </div>
        }
        {showMessage && NotificationManager.error(alertMessage)}
        <NotificationContainer/>
      </div>
    )
  }
}

const mapStateToProps = ({auth,settings}) => {
  const {loader, alertMessage, showMessage, authUser} = auth;
  const {locale} = settings;
  return {loader, alertMessage, showMessage, authUser,locale}
};

export default connect(mapStateToProps, {
  userSignUp,
  hideMessage,
  showAuthLoader,
})(SignUp);
